function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#fecb00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,11.667h30v13.333H0v-13.333Z",
    style: {
      fill: "#34b233"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,18.333h30v6.667H0v-6.667Z",
    style: {
      fill: "#ea2839"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.678 16.573 22.009 13.426 16.655 13.425 15 8.333 13.345 13.425 7.991 13.426 12.322 16.573 10.668 21.666 15.001 18.518 19.332 21.665 17.678 16.573",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMm);
export default __webpack_public_path__ + "static/media/MM.6d496aea6e73ca3aca9fe78122f2de96.svg";
export { ForwardRef as ReactComponent };